"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /** When your routing table is too long, you can split it into small modules **/
var objectRouter = {
  path: '/object',
  component: _layout.default,
  meta: {
    title: '项目管理',
    icon: 'nested'
  },
  children: [
  // 项目类型管理
  {
    path: 'objectType',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/objectType/index.vue'));
      });
    },
    // Parent router-view
    name: 'objectType',
    meta: {
      title: '项目类型管理',
      icon: 'dashboard'
    }
  }, {
    path: 'courseProEs',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/courseDeclare/courseProEs.vue'));
      });
    },
    // Parent router-view
    name: 'courseProEs',
    meta: {
      title: '立项申报',
      icon: 'dashboard'
    }
  }, {
    path: 'objectType-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/objectType/objectTypeAdd.vue'));
      });
    },
    name: 'objectType-add',
    hidden: true,
    meta: {
      title: '新增项目类型'
    }
  }, {
    path: 'objectType-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/objectType/objectTypeEdit.vue'));
      });
    },
    name: 'objectType-edit',
    hidden: true,
    meta: {
      title: '编辑项目类型'
    }
  },
  // 项目管理
  {
    path: 'object',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/index.vue'));
      });
    },
    name: 'object',
    meta: {
      title: '项目管理',
      icon: 'dashboard'
    }
  }, {
    path: 'object-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectAdd.vue'));
      });
    },
    name: 'objectAdd',
    meta: {
      title: '新增项目',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: 'object-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectEdit.vue'));
      });
    },
    name: 'objectEdit',
    meta: {
      title: '编辑项目',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: 'object-edits',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectEdit.vue'));
      });
    },
    name: 'objectEdits',
    meta: {
      title: '编辑项目',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectGroupSet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectGroupSet.vue'));
      });
    },
    name: 'objectGroupSet',
    meta: {
      title: '项目组别设置',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectGroupSet-add",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectGroupSetAdd.vue'));
      });
    },
    name: 'objectGroupSetAdd',
    meta: {
      title: '新增项目组别',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectGroupSetEdit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectGroupSetEdit.vue'));
      });
    },
    name: 'objectGroupSetEdit',
    meta: {
      title: '编辑项目组别',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectUnitSet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectUnitSet.vue'));
      });
    },
    name: 'objectUnitSet',
    meta: {
      title: '项目单位设置',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectUnitSet-add",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectUnitSetAdd.vue'));
      });
    },
    name: 'objectUnitSetAdd',
    meta: {
      title: '新增项目单位',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectStageSet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectStageSet.vue'));
      });
    },
    name: 'objectStageSet',
    meta: {
      title: '项目阶段设置',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectStageSet-add",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectStageSetAdd.vue'));
      });
    },
    name: 'objectStageSetAdd',
    meta: {
      title: '新增项目阶段',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectStageSet-edit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectStageSetEdit.vue'));
      });
    },
    name: 'objectStageSetEdit',
    meta: {
      title: '编辑项目阶段',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "technocracy",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/technocracy.vue'));
      });
    },
    name: 'objectTechnocracy',
    meta: {
      title: '专家管理',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "expertGrade",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/expertGrade.vue'));
      });
    },
    name: 'expertGrade',
    meta: {
      title: '专家分配与评分规则',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "objectStageSetAndGroupSet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/objectStageSetAndGroupSet.vue'));
      });
    },
    name: 'objectStageSetAndGroupSet',
    meta: {
      title: '项目组别设置',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "entrySet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/entrySet.vue'));
      });
    },
    name: 'entrySet',
    meta: {
      title: '参赛作品设置',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "roleSet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/roleSet.vue'));
      });
    },
    name: 'roleSet',
    meta: {
      title: '权限设置',
      icon: 'dashboard'
    },
    hidden: true
  }, {
    path: "gradeItemSet",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/object/gradeItemSet.vue'));
      });
    },
    name: 'gradeItemSet',
    meta: {
      title: '评分项设置',
      icon: 'dashboard'
    },
    hidden: true
  },
  // 专业大类设置
  {
    path: "/majorObject",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/majorObject/index.vue'));
      });
    },
    name: "majorObject",
    meta: {
      title: '专业大类设置',
      icon: 'dashboard'
    }
  }, {
    path: "majorObject-add",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/majorObject/majorObjectAdd.vue'));
      });
    },
    name: "majorObjectAdd",
    hidden: true,
    meta: {
      title: '新增专业大类',
      icon: 'dashboard'
    }
  }, {
    path: "majorObject-edit",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/object/majorObject/majorObjectEdit.vue'));
      });
    },
    name: "majorObjectEdit",
    meta: {
      title: '编辑专业大类',
      icon: 'dashboard'
    },
    hidden: true
  }]
};
var _default = exports.default = objectRouter;